import ArberShabani from "../src/images/team/arbershabani-current.png";
import EdonaRexhepi from "../src/images/team/edonarexhepi.jpeg";


export const teamMembers = [
  {
    fullName: 'Arbër Shabani',
    // position: 'CEO',
    position: 'Founder & Senior Software Engineer',
    photo: ArberShabani,
    url: 'https://coetic-x.com/cv/arber-shabani/',
    description: `
    Founder of Coetic X and senior software engineer building web and mobile products, from architecture and integrations through production releases. Works with businesses internationally, combining hands-on engineering with clear scope and direct communication. Outside engineering, enjoys helicopter flying, freediving and piano.
    `
  },
  {
    fullName: 'Edona Rexhepi',
    position: 'Chief Marketing Officer',
    photo: EdonaRexhepi,
    // url: '/cv/edona-rexhepi',
    description: `
    Experienced Chief Marketing Officer adept at achieving remarkable outcomes. Strategic visionary and influential leader, focused on enhancing marketing efforts, expanding brand reach, and attracting new customers. Skilled in developing successful marketing strategies, fostering high-performing teams, and utilizing data-driven insights to optimize campaigns and drive maximum returns on investment
    `
  },
  // {
  //   fullName: 'Erëza Krasniqi',
  //   position: 'React & React Native Engineer',
  //   photo: ErezaKrasniqi,
  //   url: '/cv/ereza-krasniqi',
  //   description: `
  //   A goal-oriented, determined, and ambitious individual with a profound passion for coding. Nearing graduation as a Computer Engineer from the Faculty of Electrical and Computer Engineering, all the while embracing new learning opportunities along her journey. With expertise in building dynamic and responsive web and mobile applications using JavaScript and its frameworks, she excels in applying modern UI/UX principles to ensure the delivery of seamless and user-friendly experiences.
  //   `,
  //   // description: `
  //   // React and React Native Developer with expertise in building dynamic and responsive web and mobile applications using JavaScript and its frameworks, employing modern UI/UX principles to deliver seamless user experiences.
  //   // `
  // },
];
